import { Box } from '@mui/material';
import React from 'react';
import { Illustration, TIllustration } from '../Illustration';
import TypographyWithShadow from '../Typography/TypographyWithShadow';
import theme, { TMaterialStyles } from '../../theme';

interface IScreenBanner {
  title?: string;
  topSubtitle?: string;
  illustrationName?: TIllustration;
  desktopIllustrationName?: TIllustration;
}

export const ScreenBanner: React.FC<IScreenBanner> = ({
  title,
  topSubtitle,
  illustrationName,
  desktopIllustrationName,
}) => {
  return (
    <Box sx={materialStyles.bannerContainer}>
      <Illustration
        sx={[
          materialStyles.bannerIllustration,
          desktopIllustrationName
            ? materialStyles.mobileBannerIllustration
            : null,
        ]}
        illustrationName={illustrationName}
      />
      {desktopIllustrationName ? (
        <Illustration
          sx={[
            materialStyles.bannerIllustration,
            materialStyles.desktopBannerIllustration,
          ]}
          illustrationName={desktopIllustrationName}
        />
      ) : null}
      {topSubtitle ? (
        <TypographyWithShadow sx={materialStyles.bannerSubtitle}>
          {topSubtitle}
        </TypographyWithShadow>
      ) : null}
      <TypographyWithShadow sx={materialStyles.bannerTitle}>
        {title}
      </TypographyWithShadow>
    </Box>
  );
};

const materialStyles: TMaterialStyles = {
  bannerContainer: {
    display: 'flex',
    width: '100%',
    maxWidth: '738px',
    minHeight: '132px',
    mx: 'auto',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0px',
    mt: {
      xs: '0px',
      lg: '16px',
    },
    flexDirection: 'column',
    overflow: 'hidden',
    boxShadow: `0px 4px 0px ${theme.palette.secondary.contrastText}`,
  },
  desktopBannerIllustration: {
    display: {
      xs: 'none',
      lg: 'block',
    },
  },
  mobileBannerIllustration: {
    display: {
      xs: 'block',
      lg: 'none',
    },
  },
  bannerIllustration: {
    width: '100%',
    maxWidth: '738px',
    objectFit: 'cover',
    height: '132px',
    position: 'absolute',
  },
  bannerTitle: {
    position: 'relative',
    fontFamily: 'Rubber Duck !important',
    zIndex: 1,
    textTransform: 'uppercase',
    fontSize: '33px',
    lineHeight: '100%',
  },
  bannerSubtitle: {
    position: 'absolute',
    fontFamily: 'Rubber Duck !important',
    zIndex: 1,
    textTransform: 'uppercase',
    fontSize: '11px',
    lineHeight: '100%',
    textAlign: 'center',
    top: '15px',
    px: '6px',
  },
};
